module.exports = __webpack_public_path__ + "img/scene2-12.1e0e7415.jpg";